module.exports = __webpack_public_path__ + "media/images/card-569109d18f788ec92373e9e2c0915a47.jpg";